<ng-container *ngIf="hasAccess">
    <ng-content></ng-content>
</ng-container>
<app-error-text *ngIf="!hasAccess && showMessageIfNoAccess" [message]="message"></app-error-text>
